const capitalize = (str = "") => (str[0]?.toUpperCase() ?? "") + str.slice(1);
export {
  capitalize
};
//# sourceMappingURL=capitalize.js.map
